const map = {
	"./core/blue_team_no_background.webp": 44218,
	"./core/red_team_no_background.webp": 66821,
	"./features/excalibur.webp": 50006,
	"./features/lady_of_lake.webp": 65705,
	"./features/lady_of_sea.webp": 65569,
	"./premium/eclipse-queen.webp": 57927,
	"./premium/puppeteer.webp": 66531,
	"./roles/anime/brute.webp": 26322,
	"./roles/anime/cleric.webp": 25350,
	"./roles/anime/evil_lancelot.webp": 11871,
	"./roles/anime/good_lancelot.webp": 34106,
	"./roles/anime/guinevere.webp": 90764,
	"./roles/anime/isolde.webp": 26870,
	"./roles/anime/lunatic.webp": 1292,
	"./roles/anime/merlin.webp": 9517,
	"./roles/anime/merlin_pure.webp": 15220,
	"./roles/anime/minion.webp": 68280,
	"./roles/anime/mordred.webp": 32087,
	"./roles/anime/morgana.webp": 66141,
	"./roles/anime/mystery.webp": 54595,
	"./roles/anime/oberon.webp": 53289,
	"./roles/anime/percival.webp": 45748,
	"./roles/anime/revealer.webp": 16172,
	"./roles/anime/revealer_hidden.webp": 98385,
	"./roles/anime/revealer_progress.webp": 90774,
	"./roles/anime/servant.webp": 86123,
	"./roles/anime/trickster.webp": 57821,
	"./roles/anime/tristan.webp": 70419,
	"./roles/anime/troublemaker.webp": 55835,
	"./roles/anime/unknown_lancelot.webp": 96371,
	"./roles/anime/witch.webp": 19293,
	"./roles/anime/wraith.webp": 23473,
	"./roles/brute.webp": 24277,
	"./roles/cleric.webp": 88723,
	"./roles/evil_lancelot.webp": 54964,
	"./roles/good_lancelot.webp": 48945,
	"./roles/guinevere.webp": 41579,
	"./roles/isolde.webp": 76499,
	"./roles/legacy/brute.webp": 54835,
	"./roles/legacy/cleric.webp": 79953,
	"./roles/legacy/evil_lancelot.webp": 47278,
	"./roles/legacy/good_lancelot.webp": 24555,
	"./roles/legacy/guinevere.webp": 88193,
	"./roles/legacy/isolde.webp": 82789,
	"./roles/legacy/lunatic.webp": 3101,
	"./roles/legacy/merlin.webp": 20502,
	"./roles/legacy/merlin_pure.webp": 90653,
	"./roles/legacy/minion.webp": 56779,
	"./roles/legacy/mordred.webp": 47390,
	"./roles/legacy/morgana.webp": 98480,
	"./roles/legacy/mystery.webp": 34026,
	"./roles/legacy/oberon.webp": 83762,
	"./roles/legacy/percival.webp": 54875,
	"./roles/legacy/revealer.webp": 95119,
	"./roles/legacy/revealer_hidden.webp": 70372,
	"./roles/legacy/revealer_progress.webp": 76163,
	"./roles/legacy/servant.webp": 58742,
	"./roles/legacy/trickster.webp": 13336,
	"./roles/legacy/tristan.webp": 20862,
	"./roles/legacy/troublemaker.webp": 13872,
	"./roles/legacy/unknown_lancelot.webp": 35712,
	"./roles/legacy/witch.webp": 75936,
	"./roles/legacy/wraith.webp": 58826,
	"./roles/lunatic.webp": 67487,
	"./roles/merlin.webp": 50932,
	"./roles/merlin_pure.webp": 77951,
	"./roles/minion.webp": 50045,
	"./roles/mordred.webp": 43996,
	"./roles/morgana.webp": 15898,
	"./roles/mystery.webp": 10244,
	"./roles/oberon.webp": 54916,
	"./roles/percival.webp": 4917,
	"./roles/revealer.webp": 99529,
	"./roles/revealer_hidden.webp": 51754,
	"./roles/revealer_progress.webp": 74869,
	"./roles/servant.webp": 65968,
	"./roles/trickster.webp": 79886,
	"./roles/tristan.webp": 30060,
	"./roles/troublemaker.webp": 72810,
	"./roles/unknown_lancelot.webp": 91558,
	"./roles/witch.webp": 43010,
	"./roles/wraith.webp": 21152
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6300;